import React, { useState, useEffect } from "react";
import styled from "styled-components";

const Contain = styled.div`
  background-color: #839CC2;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const FormContainer = styled.div`
  padding: 20px;
  width: 51%;
`;

const FormHeading = styled.h2`
  font-size: 24px;
  color: #333;
  margin-bottom: 10px;
  font-family: "Montserrat", sans-serif;
  font-weight: bold;
  b {
    color: #F29755;
  }
`;

const StyledForm = styled.form`
  display: flex;
  flex-direction: column;
`;

const FormField = styled.div`
  margin-bottom: 15px;
`;

const Input = styled.input`
  width: 97.3%;
  padding: 10px;
  font-size: 16px;
  border: 1px solid #ccc;
  border-radius: 20px;
`;

const Select = styled.select`
  width: 100%;
  padding: 10px;
  font-size: 16px;
  border: 1px solid #ccc;
  border-radius: 20px;
`;

const CheckboxLabel = styled.label`
  display: flex;
  align-items: center;
  font-size: 14px;
  font-family: "Montserrat", sans-serif;
  font-weight: bold;
`;

const Checkbox = styled.input`
  margin-right: 10px;
`;

const SubmitButton = styled.button`
  background-color: #0C1A3B;
  color: white;
  padding: 10px;
  font-size: 16px;
  border: none;
  border-radius: 20px;
  cursor: pointer;

  &:hover {
    background-color: white;
    color: black;
  }

  &:disabled {
    background-color: #ccc;
    cursor: not-allowed;
  }
`;

export default function OpenForm() {
    const [formData, setFormData] = useState({
        name: "",
        contact: "",
        departureCity: "",
        finalCity: "",
        passengers: "",
        departureDate: "",
        returnDate: "",
        month: "",
        days: "",
        baggage: false,
        flexData: false,
    });

    const [isFormValid, setIsFormValid] = useState(false);

    // Formata número de celular
    const formatPhone = (value) => {
        let cleaned = value.replace(/\D/g, "");
        if (cleaned.length <= 10)
            return cleaned.replace(/(\d{2})(\d{4})(\d{0,4})/, "($1) $2-$3");
        return cleaned.replace(/(\d{2})(\d{5})(\d{0,4})/, "($1) $2-$3");
    };

    // Formata data
    const formatDate = (value) => {
        const cleanValue = value.replace(/\D/g, "");
        if (cleanValue.length <= 2) return cleanValue;
        if (cleanValue.length <= 4)
            return `${cleanValue.slice(0, 2)}/${cleanValue.slice(2)}`;
        return `${cleanValue.slice(0, 2)}/${cleanValue.slice(2, 4)}/${cleanValue.slice(4, 8)}`;
    };

    // Atualiza o estado dos campos
    const handleInputChange = (e) => {
        const { name, value, type, checked } = e.target;

        setFormData((prev) => ({
            ...prev,
            [name]:
                name === "departureDate" || name === "returnDate"
                    ? formatDate(value)
                    : name === "contact"
                        ? formatPhone(value)
                        : type === "checkbox"
                            ? checked
                            : value,
        }));
    };

    // Verifica se todos os campos obrigatórios estão preenchidos
    const checkFormValidity = () => {
        const {
            name,
            contact,
            departureCity,
            finalCity,
            passengers,
            flexData,
            departureDate,
            returnDate,
            month,
            days,
        } = formData;

        if (
            name &&
            contact &&
            departureCity &&
            finalCity &&
            passengers &&
            ((flexData && month && days) || (!flexData && departureDate && returnDate))
        ) {
            setIsFormValid(true);
        } else {
            setIsFormValid(false);
        }
    };

    useEffect(() => {
        checkFormValidity();
    }, [formData]);

    // Envio para o WhatsApp
    async function orderPack(e) {
        e.preventDefault();
        console.log("Enviando cotação...");

        const {
            name,
            contact,
            departureCity,
            finalCity,
            passengers,
            departureDate,
            returnDate,
            month,
            days,
            baggage,
            flexData,
        } = formData;

        const luggageStatus = baggage ? "Sim" : "Não";
        const flexibleStatus = flexData ? "Sim" : "Não";

        const deal_custom_fields = [
            { value: departureCity },
            { value: finalCity },
            { value: days },
            { value: month },
            { value: passengers },
            { value: luggageStatus },
            { value: departureDate },
            { value: returnDate },
        ];

        const payload = {
            deal: {
                name: `Cotação - ${name}`,
                deal_custom_fields,
            },
            contacts: [
                {
                    name: name,
                    phones: [{ type: "cellphone", phone: contact }],
                },
            ],
        };

        try {
            const response = await fetch("https://voecheapserverrdstation.onrender.com/api/create-deal", {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(payload),
            });

            if (!response.ok) {
                throw new Error(`Erro HTTP: ${response.status}`);
            }

            const result = await response.json();
            console.log("Negociação enviada com sucesso!", result);

            alert("Cotação enviada com sucesso! Em breve entraremos em contato.");
        } catch (error) {
            console.error("Erro ao enviar negociação:", error);
            alert("Ocorreu um erro ao enviar sua cotação. Tente novamente mais tarde.");
        }
    }


    return (
        <Contain>
            <FormContainer>
                <FormHeading>
                    Preencha o formulário para pedir uma cotação personalizada:
                </FormHeading>
                <StyledForm onSubmit={orderPack}>
                    <FormField>
                        <Input
                            type="text"
                            name="name"
                            placeholder="Digite seu nome"
                            value={formData.name}
                            onChange={handleInputChange}
                        />
                    </FormField>

                    <FormField>
                        <Input
                            type="tel"
                            name="contact"
                            placeholder="Digite seu celular"
                            value={formData.contact}
                            onChange={handleInputChange}
                            maxLength="15"
                        />
                    </FormField>

                    <FormField>
                        <Input
                            type="text"
                            name="departureCity"
                            placeholder="Cidade de partida"
                            value={formData.departureCity}
                            onChange={handleInputChange}
                        />
                    </FormField>

                    <FormField>
                        <Input
                            type="text"
                            name="finalCity"
                            placeholder="Cidade de destino"
                            value={formData.finalCity}
                            onChange={handleInputChange}
                        />
                    </FormField>

                    <FormField>
                        <Input
                            type="number"
                            name="passengers"
                            placeholder="Quantidade de passageiros"
                            value={formData.passengers}
                            onChange={handleInputChange}
                        />
                    </FormField>

                    <FormField>
                        <CheckboxLabel>
                            <Checkbox
                                type="checkbox"
                                name="flexData"
                                checked={formData.flexData}
                                onChange={handleInputChange}
                            />
                            TENHO FLEXIBILIDADE NAS DATAS
                        </CheckboxLabel>
                    </FormField>

                    {/* Se datas NÃO forem flexíveis, mostra ida e volta */}
                    {!formData.flexData && (
                        <>
                            <FormField>
                                <Input
                                    type="text"
                                    name="departureDate"
                                    placeholder="Data de ida (dd/mm/aaaa)"
                                    value={formData.departureDate}
                                    onChange={handleInputChange}
                                    maxLength="10"
                                />
                            </FormField>

                            <FormField>
                                <Input
                                    type="text"
                                    name="returnDate"
                                    placeholder="Data de volta (dd/mm/aaaa)"
                                    value={formData.returnDate}
                                    onChange={handleInputChange}
                                    maxLength="10"
                                />
                            </FormField>
                        </>
                    )}

                    {/* Se for flexível, mostra mês e duração */}
                    {formData.flexData && (
                        <>
                            <FormField>
                                <Select
                                    name="month"
                                    value={formData.month}
                                    onChange={handleInputChange}
                                >
                                    <option value="">Selecione o mês</option>
                                    {[
                                        "Janeiro",
                                        "Fevereiro",
                                        "Março",
                                        "Abril",
                                        "Maio",
                                        "Junho",
                                        "Julho",
                                        "Agosto",
                                        "Setembro",
                                        "Outubro",
                                        "Novembro",
                                        "Dezembro",
                                    ].map((m) => (
                                        <option key={m} value={m}>
                                            {m}
                                        </option>
                                    ))}
                                </Select>
                            </FormField>

                            <FormField>
                                <Input
                                    type="number"
                                    name="days"
                                    placeholder="Quantidade de dias"
                                    value={formData.days}
                                    onChange={handleInputChange}
                                />
                            </FormField>
                        </>
                    )}

                    <FormField>
                        <CheckboxLabel>
                            <Checkbox
                                type="checkbox"
                                name="baggage"
                                checked={formData.baggage}
                                onChange={handleInputChange}
                            />
                            QUERO BAGAGEM DE 23KG
                        </CheckboxLabel>
                    </FormField>



                    <SubmitButton type="submit" disabled={!isFormValid}>
                        PEDIR COTAÇÃO PERSONALIZADA
                    </SubmitButton>
                </StyledForm>
            </FormContainer>
        </Contain>
    );
}
